import http from "../http-common";

const API_URL = "/auth/";

class AuthService {
  login(username, password) {
    return http
      .post(API_URL + "signin", {
        username,
        password
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  // Verify recaptcha
  verifyRecaptcha(token) {
    return http.post(API_URL + "verify-recaptcha", {
      token
    });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return http.post(API_URL + "signup", {
      username,
      email,
      password
    });
  }

  resetPassword(token, newPassword) {
    return http.post(API_URL + "reset-password", {
      token,
      newPassword
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));;
  }

  getAccessToken() {
    const user = this.getCurrentUser();
    return user ? user.accessToken : null;
  }
}

export default new AuthService();
